import Vue from "vue";
import VueI18n from "vue-i18n";
import storageClient from "@/services/storageClient";
import { LOCALE_MESSAGES, FALLBACK_LOCALE, normalizeLocale } from "@/utils/allowedLocales";

Vue.use(VueI18n);

const storedLocale = storageClient.getLanguage();
const browserLocale = window.navigator.language?.slice(0, 2);
const locale = normalizeLocale(storedLocale || browserLocale);

export default new VueI18n({
  locale,
  fallbackLocale: FALLBACK_LOCALE,
  silentFallbackWarn: true,
  messages: LOCALE_MESSAGES
});
